export default "__VITE_PUBLIC_ASSET__008d44c2__"